// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"bdd091cb","166":"88141663","182":"18df3fe3","241":"a585f926","309":"c7b14528","370":"19bbfc78","418":"3c731fb7","419":"b5f4b6a7","982":"55e77ab5","989":"faee12bd"}[chunkId] + ".chunk.js";
};